import PropTypes from 'prop-types'
import { useRef } from 'react'
import SwiperCore, { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

// Internal components
import Svg from '../Svg/Svg'
import DetailCard from '../DetailCard/DetailCard'

const Slideshow = (props) => {
  const { title, cards, modifiers, entryId } = props
  const nextButton = useRef()
  const prevButton = useRef()

  SwiperCore.use([Navigation])

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  const createSwiper = (cards) => {
    return (
      <Swiper
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = prevButton.current
          swiper.params.navigation.nextEl = nextButton.current
          swiper.navigation.init()
          swiper.navigation.update()
        }}
        key={entryId}
        slidesPerView={'auto'}
        className={'Slideshow-container'}
        slideClass={'Slideshow-slide'}
      >
        {cards &&
          cards.map((card, index) => {
            return (
              <SwiperSlide className="Slideshow-slide" key={`Slideshow-slide--${card.id}_${entryId}_${index}}`}>
                <DetailCard
                  cardData={card}
                  cardIndex={index}
                  direction={'horizontal'}
                  cardType={'slideshow'}
                  modifiers={'DetailCard--slideshow'}
                />
              </SwiperSlide>
            )
          })}
      </Swiper>
    )
  }

  return (
    <div className={`Slideshow${modifierClasses}`}>
      {cards[0] && (
        <div className="Slideshow-inner">
          {title && (
            <div className="Slideshow-header">
              <h3 className="Slideshow-title">{title}</h3>

              <div className="Slideshow-controls">
                <button className="Slideshow-control Slideshow-control--prev" ref={prevButton}>
                  <Svg modifiers={['Slideshow-controlIcon']} id="icon-thin-arrow-left" />
                </button>
                <button className="Slideshow-control Slideshow-control--next" ref={nextButton}>
                  <Svg modifiers={['Slideshow-controlIcon']} id="icon-thin-arrow-right" />
                </button>
              </div>
            </div>
          )}
          <div className="Slideshow-content">{cards?.length ? <> {createSwiper(cards)}</> : ''}</div>
        </div>
      )}
    </div>
  )
}

Slideshow.propTypes = {
  title: PropTypes.string,
  cards: PropTypes.array.isRequired,
  entryId: PropTypes.any,
  modifiers: PropTypes.array
}

export default Slideshow
